export enum PreauthStatus {
  Preauthorized = 'PREAUTHORIZED',
  PreauthorizationRequired = 'PREAUTHORIZATION_REQUIRED',
  Pending = 'PENDING',
  MissingPaymentMethod = 'MISSING_PAYMENT_METHOD',
}
